import React from 'react';
import './style.css'

function navbar() {
    return(
        <div className="Navbar">Pokemon API</div>
    )
}

export default navbar